import React, { useState } from "react";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import styled from "styled-components";
import { SmallCard } from "styled_components/Common/SmallCard";
import { ShareBackSide } from "styled_components/Storage/ShareBackSide";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const RedundancyIcon = `${CDN_URL}storage/Storage-mirror-arrows-inactive.svg`;
const SmallPublicIcon = `${CDN_URL}storage/Storage-public-icon-gray`;
const SmallPrivateIcon = `${CDN_URL}storage/Storage-private-icon-default.svg`;

const SharesBodyStyle = styled.div`
  width: 100%;
  height: 191px;
  align-self: flex-start;
  border: none;
  .shares-wrapper {
    width: 100%;
    height: 100%;
    margin-top: 10px;
    margin-left: 10px;
    display: flex;
    flex-wrap: wrap;

    .share-card {
      margin-top: 10px;
    }
  }

  .ScrollbarsCustom-Track {
    right: 7px !important;
    top: 20px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.storage} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 100%;
    height: 304px;
    align-self: flex-start;
    .shares-wrapper {
      width: 100%;
      height: 100%;
      margin-top: 10px;
      margin-left: 32px;
      display: flex;
      flex-wrap: wrap;

      .share-card {
        margin-top: 5px;
      }
    }

    .ScrollbarsCustom-Track {
      right: 17px !important;
      top: 20px !important;
    }
    .ScrollbarsCustom-ThumbY {
      width: 8px !important;
    }

    .ScrollbarsCustom-TrackY {
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 100%;
    height: 460px;
    align-self: flex-start;
    .shares-wrapper {
      width: 100%;
      height: 100%;
      margin-top: 10px;
      margin-left: 40px;
      display: flex;
      flex-wrap: wrap;

      .share-card {
        margin-top: 5px;
      }
    }

    .ScrollbarsCustom-Track {
      right: 32px !important;
      top: 30px !important;
    }
    .ScrollbarsCustom-ThumbY {
      width: 8px !important;
    }

    .ScrollbarsCustom-TrackY {
      width: 8px !important;
    }
  }
`;

function mapData(shares) {
  const data = [];

  if (!shares) {
    return data;
  }

  shares.map((share) => {
    const deleted =
      share.status === "deleted" || share.status === "pending_delete"
        ? " deleted"
        : "";
    const pending =
      share.status === "pending" || share.status === "processing"
        ? "pending"
        : "";
    const replication = share.replication ? RedundancyIcon : null;
    const privacy = !share?.isPrivate ? SmallPublicIcon : SmallPrivateIcon;

    data.push({
      id: share?.storage_id,
      image: "image-url",
      name: share?.common_name,
      topLeftIcon: replication,
      topRightIcon: privacy,
      mainIcon: share?.icon,
      deleted,
      pending,
      type: share?.storage_type,
      icon: share?.icon,
      iconColor: share?.icon_color,
      replication: share?.replication,
      currentSizeGB: share?.currentSizeGB,
      currentSizeMB: share?.currentSizeMB,
      currentSizePB: share?.currentSizePB,
      currentSizeTB: share?.currentSizeTB,
    });
  });
  return data;
}

export const SharesBody = ({
  cypressId,
  id,
  data,
  onClick,
  total,
  unit,
  orgId,
  navigate,
}) => {
  const formattedData = mapData(data);
  const [selected, setSelectedShare] = useState(null);

  return (
    <SharesBodyStyle id={id} data-cy={cypressId} className="shares-body">
      {!selected && (
        <ScrollView>
          <div className="shares-wrapper">
            {formattedData &&
              formattedData.length !== 0 &&
              formattedData.map((item, index) => (
                <SmallCard
                  key={`share-card-${item?.id}-${index + 1}`}
                  index={index}
                  selected={"xs"}
                  cypressId={`card-${index}`}
                  onClick={onClick}
                  data={item}
                  id={item?.id}
                  pending={item?.pending}
                  deleted={item?.deleted}
                  hoverButton={true}
                  hoverClick={() => setSelectedShare(item)}
                  type="share"
                />
              ))}
          </div>
        </ScrollView>
      )}
      {selected && (
        <ShareBackSide
          share={selected}
          onClick={setSelectedShare}
          total={total}
          unit={unit}
          orgId={orgId}
          navigate={navigate}
        />
      )}
    </SharesBodyStyle>
  );
};
